<template>
  <div>
    <div style="padding:30px; background: #FFFFFF; 
    box-shadow:rgb(107 105 105 / 21%) 0px 0px 20px 0px; 
    border-radius: 10px;">
      <div
        style="
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #333333;
          margin-bottom: 20px;
        "
      >
        我的账单
      </div>
      <!-- <div style="min-width: 1200px">
        <el-row :gutter="20">
          <el-col style="min-width:450px;margin-bottom:20px" :span="8">
            <div class="grid-content bg-purple" style="width:450px">
              <span
                style="width:80px
                  font-size: 14px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #333333;
                  margin-right: 20px;
                "
              >
                支付时间
              </span>
              <el-date-picker
                @change="pickerChange"
                v-model="value1"
                value-format="yyyy-MM-dd"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="8" style="margin-bottom:20px">
            <div
              class="grid-content bg-purple"
              style="display: flex; align-items: center"
            >
              <span
                style="
                  font-size: 14px;
                  min-width: 50px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #333333;
                  margin-right: 20px;
                "
              >
                账单号
              </span>
              <el-input
                placeholder="请输入账单号"
                clearable
                v-model="id"
                style="width: 240px"
              >
              </el-input>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <span
                style="
                  font-size: 14px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #333333;
                  margin-right: 20px;
                "
              >
                账单状态
              </span>
              <el-select
                style="width: 107px"
                v-model="state"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.state"
                  :label="item.name"
                  :value="item.state"
                >
                </el-option>
              </el-select>

              <el-button
                @click="getListByParams(1)"
                style="margin-left: 20px"
                type="primary"
                >查询</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div> -->
       <div style="display:flex;flex-wrap: wrap;">
            <div class="grid-content bg-purple" style="margin-right:41px;margin-bottom: 10px;min-width:460px">
              <span
                style="
                  font-size: 14px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #333333;
                  margin-right: 20px;
                "
              >
                费用产生时间
              </span>
              <el-date-picker
                 @change="pickerChange"
                v-model="value1"
                value-format="yyyy-MM-dd"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
            <div
              class="grid-content bg-purple"
              style="margin-bottom: 10px;min-width:310px;margin-right:41px;display: flex; align-items: center"
            >
              <span
                style="
                  font-size: 14px;
                  min-width: 50px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #333333;
                  margin-right: 20px;
                "
              >
                账单号
              </span>
              <el-input
                placeholder="请输入账单号"
                v-model.trim="id"
                clearable
                style="width: 240px"
              >
              </el-input>
            </div>
            <div class="grid-content bg-purple" style="
            min-width:285px">
              <span
                style="
                  font-size: 14px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #333333;
                  margin-right: 20px;
                "
              >
                费用状态
              </span>
              <el-select
                style="width: 107px"
                v-model="state"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.state"
                  :label="item.name"
                  :value="item.state"
                >
                </el-option>
              </el-select>

              <el-button
                @click="getListByParams(1)"
                style="margin-left: 20px;height:32px;line-height:2px"
                type="primary"
                @keyup.enter="enterSearch"
                >查询</el-button
              >
            </div>
      </div>
       
      <div style="margin-top:10px">
        <el-table
          ref="multipleTable"
          align="center"
          :header-cell-style="{
            background: '#eef1f6',
            color: '#606266',
          }"
          border
          highlight-current-row
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column width="60" align="center" label="序号" type="index">
          </el-table-column>
          <el-table-column align="center" prop="billNo" label="账单号">
          </el-table-column>

          <el-table-column align="center" prop="amount" label="支付金额">
                 <template slot-scope="scope">
              <span>{{scope.row.amount }} {{scope.row.currency }}</span>
            
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="createBillTime"
            label="账单产生时间"
          >
          </el-table-column>
          <el-table-column align="center" prop="state" label="账单状态">
            <template slot-scope="scope">
              <span v-if="scope.row.state == 'I'">待支付</span>
              <span v-if="scope.row.state == 'C'">待确认</span>
              <span v-if="scope.row.state == 'S'">已完成</span>
              <span v-if="scope.row.state == 'D'">已作废</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="payTime" label="支付时间">
             <template slot-scope="scope">
              <span>{{scope.row.payTime ? scope.row.payTime : '-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="payType" label="支付方式">
            <template slot-scope="scope">
              <span v-if="scope.row.payType == 'B'">微信支付</span>
              <span v-else-if="scope.row.payType == 'A'">支付宝</span>
              <span v-else-if="scope.row.payType == 'C'">线下</span>
              <span v-else-if="scope.row.payType == 'D'">线上</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <div style="display: flex;justify-content: center;">
                    <router-link
                    :to="{
                      name: 'PayDetail',
                      query: { id: scope.row.id, state: scope.row.state ,billNo: scope.row.billNo,amount: scope.row.amount},
                    }"
                  >
                    <span style="color: #9a9a9a" class="myCursor">查看详情</span>
                  </router-link>
                  <div style="width:60px;">
                          <div v-if="scope.row.isHaveImg"
                    style="color: #FF4D01; margin-left: 20px;width:60px;"
                    class="myCursor"
                    @click="checkPic(scope.row.id)"
                    >查看水单</div
                  >
                  </div>
                
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 20px; float: right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20,30,40, 50]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
        <div style="clear:both"></div>
      </div>
      <el-dialog
        title="水单信息"
        :visible.sync="shwoPics"
        width="50%" center
        >
        <div style="height: 500px;overflow: overlay">
         
          <div style="text-align:center"  v-for="(url,index) in picPaths" :key="index"  >
          
           <img @click="openPic(url)" :src="url" style="width: 100%;margin-top:5px;cursor:pointer" alt="">
            <!-- <el-image style="width: 100%;margin-top:5px" fit="contain"
             :src="url" lazy></el-image>      -->
            <el-tag v-if="picPaths.length > 1">第 {{index + 1}} 张图片</el-tag>
          </div>
           <el-dialog :modal="false" :visible.sync="dialogVisible1">
            
            <div style="text-algin:center;position:relative">
              
       <img ref="imgRef"
        style="width:100%;height:100%;max-height:500px" 
        :src="dialogImageUrl" alt="" />

              <div style="bottom:10%;zoom: 50%;position: absolute;opacity: 0.4; width: 100%; text-align: center; z-index: 1;">
                  <el-button
               style="width:100px"
                type="primary"
                 @click="rotate()">旋转</el-button>
                  <el-button
               style="width:100px"
                type="primary"
                 @click="rotate('big')">放大</el-button>
                 <el-button
               style="width:100px"
                type="primary"
                 @click="rotate('small')">缩小</el-button>
                 <el-button
               style="width:100px"
                type="primary"
                 @click="closePic()">关闭</el-button>
              </div>
            </div>
          </el-dialog>
       
        </div>
          <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="shwoPics = false">返 回</el-button>
        </span>
    </el-dialog>
    </div>
    
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogImageUrl:'',
      dialogVisible1:false,
      deg:0,
      scale:0,
      id: "",
      prefix: "",
      beginTime: "",
      tableData: [],
      multipleSelection: [],
      billBeginTime: "",
      billEndTime: "",
      billNo: "",
      state: "",
      statusList: [
        {
          name: "全部",
          state: "",
        },
        {
          name: "待支付",
          state: "I",
        },
        {
          name: "待确认",
          state: "C",
        },
        {
          name: "已完成",
          state: "S",
        },
        // {
        //   name: "已作废",
        //   state: "D",
        // },
      ],
      currentPage: 1,
      total: 0,
      pageSize: 10,
      value1: [],
      nos: "",
      shwoPics:false,
      picPaths:[],
      fileList: [{name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}, {name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}]

    };
  },
  watch: {},
  methods: {
    closePic(){
         this.dialogVisible1 = false
          this.dialogImageUrl = ''
          this.$refs.imgRef.style.transform = ''
          this.scale = 0
          this.deg = 0
    },
    openPic(url){
      this.dialogImageUrl = url
      this.dialogVisible1 = true
    },
     rotate(type){
      if(type == 'big'){
        if(this.scale > 5){
           this.$message.info('已经是最大了')
          return
        }
          this.scale++
          this.$refs.imgRef.style.transform = `rotate(0deg) scale(1.${this.scale})`
       
        return
      }
      if(type == 'small'){
        if(this.scale <= 0){
          this.$message.info('已经是最小了')
          return
        }
          this.scale--
          this.$refs.imgRef.style.transform = `rotate(0deg) scale(1.${this.scale})`
       
        return
      }
       
       if(this.deg >= 360){
         this.deg = 0
         this.deg += 90
         this.$refs.imgRef.style.transform = `rotate(${this.deg}deg) scale(1.${this.scale})`
        
       }else{
        this.deg += 90
         this.$refs.imgRef.style.transform = `rotate(${this.deg}deg) scale(1.${this.scale})`
       }
    },
     
    pickerChange(e) {
      console.log(this.value1);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1
      this.getListByParams();
    },
    handleCurrentChange(val) {
       this.currentPage = val;
      this.getListByParams();
    },
    // 获取水单
    checkPic(id) {
      this.axios
        .get("/arap/getTransferVoucher/" + id)
        .then((res) => {
          
          if (res.data.code == 200) {
            if(res.data.datas.length > 0){
              this.shwoPics = true;
              this.picPaths = res.data.datas
              return
            }
            this.$message.info(res.data.message)
            return;
          }
          this.$message.info(res.data.message);
        })
        .catch((res) => {});
    },

    getDetail(id) {
      this.$router.push("PayDetail?id=" + id);
      return;
      this.axios
        .get("/arap/getFinaBillWebSingleList/" + "18939962000")
        .then((res) => {})
        .catch((res) => {});
    },
    // 根据参数查询
    getListByParams(type) {
      let user = this.sessionGetUserInfo();
      let param = {
        billBeginTime: "",
        billEndTime: "",
        billNo: "",
        curPage: this.currentPage,
        customerId: user.customerid,
        pageSize: this.pageSize,
        startIndex: 0,
        state: "",
      };
      if (type == 1) {
        param.curPage = 1;
      }
      if (this.value1 == null) {
      } else {
        if (this.value1.length > 1) {
          param.billBeginTime = this.value1[0];
          param.billEndTime = this.value1[1];
        }
      }
      if (this.id) {
        param.billNo = this.id.trim();
      }
      if (this.state) {
        param.state = this.state;
      }

      this.axios
        .post("/arap/getFinaBillWebList", param)
        .then((res) => {
          if (res.data.code == 200) {
            if (res.data.data.datalList.length > 0) {
              this.tableData = res.data.data.datalList;
              this.total = res.data.data.totalCounts;

              return;
            }
            this.$message.info("无相关记录");
            this.tableData = [];
            this.total = res.data.data.totalCounts;
            return;
          }
          this.$message.info(res.data.message);
          console.log(res);
        })
        .catch((res) => {
          console.log(res);
        });
    },
    getList() {
      let user = this.sessionGetUserInfo();

      this.axios
        .post("/arap/getFinaBillWebList", {
          billBeginTime: "",
          billEndTime: "",
          billNo: "",
          curPage: this.currentPage,
          customerId: user.customerid,
          pageSize: this.pageSize,
          startIndex: 0,
          state: "",
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.tableData = res.data.data.datalList;
            this.total = res.data.data.totalCounts;

            return;
          }
          this.$message.info(res.data.message);
          console.log(res);
        })
        .catch((res) => {
          console.log(res);
        });
    },
    toPay() {
      this.$router.push("/index/Personalindex/payOrder");
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      console.log(val);
    },
       // enter回车搜索
    enterSearch(){
      document.onkeydown = e => {
        if(e.keyCode == 13){
          this.getListByParams(1)
        }
      }
    },
  },
  created() {
    if (sessionStorage.getItem('billOrderType')) {
      this.state = 'I'
      sessionStorage.removeItem('billOrderType')
      this.getListByParams()
    } else {
      this.getList();
    }
    this.enterSearch()
  },
  mounted() {
    
  },
};
</script>
<style scoped>
.tableBorderMy {
  border: 1px solid #e7e7e7;
}
.tableBorderMyBtn {
  border-bottom: 1px solid #e7e7e7;
}
.myCursor {
  cursor: pointer;
}

.el-pagination >>> .el-pagination__total {
 line-height: 36px !important;
}

/deep/ .el-form-item{
  margin-bottom: 8px;
  line-height: 28px;
}

/deep/ .el-input__inner{
  height: 34px;
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/billType/PayRecord.vue